import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OpeningBalanceTestingInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OpeningBalanceTestingInternalControls({ onBack, setActiveSection, controlsListSection }: OpeningBalanceTestingInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Opening Balance Testing"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
